import rtkQueryHooks from '../impl/rtk-redux.hook.js'
import { createCachedGraph } from './graph.hook.js'

const cachedGraph = createCachedGraph(rtkQueryHooks)

export { cachedGraph as graphHooks }
export type { EntityUpdateFn } from '../graph-types.js'
